<template>
  <div class="financeApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    
    <div class="scenicList">
      <img class="fmt" :src="baseUrl+setDetail.img" />
      <div class="con">
        <h2>{{setDetail.title}}</h2>
        <p>营业时间：{{setDetail.business}}</p>
        <p>近期浏览：{{setDetail.read_num}}次</p>
      </div>
      <div class="level">景区等级：<font>{{setDetail.level}}</font>
        <span @click="toPush(setDetail.id,'role')">超级管理员<img src="~assets/images/icon5.png"></i></span>
      </div>
    </div>
    
    <div class="parkData">
      <h2>
        <div>财务收支情况统计</div>
        <div class="amounts">
          <span>{{moneyTotal}} <font>({{status == 1 ? 2026 : status == 2 ? 2025 : status == 3 ? 2024 : 2023}}年数据)</font></span>
          <div class="tab">
            <a :class="status == 1 ? 'curt' : ''" @click="moneysClick(1)">2026年</a>
            <a :class="status == 2 ? 'curt' : ''" @click="moneysClick(2)">2025年</a>
            <a :class="status == 3 ? 'curt' : ''" @click="moneysClick(3)">2024年</a>
            <a :class="status == 4 ? 'curt' : ''" @click="moneysClick(4)">2023年</a>
          </div>
        </div>
      </h2>
      <div id="money" style="height:180px;margin-top:30px"></div>
    </div>

    <div class="parkData">
      <h2>
        <div>财务收支情况</div>
        <div class="amounts">
          <span>{{setData.total}} <font>({{ys}}年数据)</font></span>
          <div class="tab">
            <a :class="ys == 2026 ? 'curt' : ''" @click="moneysClick1(2026)">2026年</a>
            <a :class="ys == 2025 ? 'curt' : ''" @click="moneysClick1(2025)">2025年</a>
            <a :class="ys == 2024 ? 'curt' : ''" @click="moneysClick1(2024)">2024年</a>
            <a :class="ys == 2023 ? 'curt' : ''" @click="moneysClick1(2023)">2023年</a>
          </div>
        </div>
      </h2>

      <ul>
        <li v-for="(item,i) in setData.rs">
          <h2><img src="https://thirdwx.qlogo.cn/mmopen/vi_32/XZtFqdl9smMCdLiaxzYzjMHDObFkibDXRBQicxKcYNtJan2xtmicaUsRFuF3eia33wJeXrK0MxqF7uYfgJ3BicQUMq4A/132" />{{item.name}}</h2>
          <p>收入来源：{{item.title}}</p>
          <p>订单编号：{{item.number}}</p>
          <p>到账时间：{{item.paytime}}</p>
          <div class="sr">收入{{item.price}}元</div>
        </li>
      </ul>
    </div>

    <div style="height:15px;"></div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setData:[],
        setDetail:[],
        status:1,
        moneyTotal:0,
        years:2026,
        ys:2026
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getMoney()
      this.ryMoney();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/spot',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setDetail = res;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getMoney:function(e){
        var that = this;
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/moneyAll',
          params:{
            id:id,
            status:that.status
          }
        }).then(function(response){
          var res = response.data.data;
          that.moneyTotal = res.total;
          that.money(res);
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      moneysClick:function(d){
        this.status = d;
        this.getMoney();
      },
      
      money:function(msg){
        var myChart = this.$echarts.init(document.getElementById('money'));
        var option;
        option = {
          color:['#FFB300','#C549FF','#3D75FE'],
            tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}  ({d}%)"
          },
          legend: {
            top: '55',
            orient: 'vertical',
            x: '65%',
            y: 'center',
            itemWidth: 12,   // 设置图例图形的宽
            itemHeight: 12,  // 设置图例图形的高
            textStyle: {
              color: '#333333',  // 图例文字颜色
              padding:[5,0]
            },
          },
          series: [{
            name: '',
            type: 'pie',
            radius: ['35%', '85%'],
            center: ['33%', '50%'],
            avoidLabelOverlap: false,
            label: {
                show: false,
                position: 'center'
            },
            data: msg.data,
          },
          {
            name: '外边框',
            type: 'pie',
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            center: ['33%', '50%'],
            radius: ['95%', '95%'],
            label: {
                normal: {
                  show: false
                }
            },
            data: [{
                value: 3,
                name: '',
                itemStyle: {
                    normal: {
                        borderWidth: 1,
                        borderType: 'dotted',//dotted 虚线
                        borderColor: '#93E0D9'
                    }
                }
            }]
          }]
        };
        option && myChart.setOption(option);
      },

      moneysClick1:function(d){
        this.ys = d;
        this.ryMoney();
      },
      ryMoney:function(){
        var id = this.$route.query.id
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/index/getMoney',
          params:{
            id:id,
            years:that.ys
          }
        }).then(function(response){
          that.setData = response.data.data;
        }).catch(err=>{

        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .financeApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .financeApp .scenicList{
    width:92%;
    margin:0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px
  }
  .financeApp .scenicList img{
    float:left;
    width:35%;
    margin:10px;
    border-radius:4px
  }
  .financeApp .scenicList .con{
    float:left;
    width:55%;
    margin-top:10px;
  }
  .financeApp .scenicList .con h2{
    font-size:15px;
    color:#333;
    letter-spacing: 1px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .financeApp .scenicList .con p{
    font-size:14px;
    color:#666;
    margin-top:13px;
  }
  .financeApp .scenicList .level{
    clear:both;
    width:92%;
    margin:0 auto;
    font-size:15px;
    border-top:1px #fafafa solid;
    padding:10px 0 15px 0;
    color:#666
  }
  .financeApp .scenicList .level font{
    color:#f00;
    font-weight:bold;
  }
  .financeApp .scenicList .level span{
    float:right;
    font-size:12px;
    color:#999;
    margin-top:2px
  }
  .financeApp  .scenicList .level span img{
    float:right;
    width:6px;
    margin:2px 0 0 8px
  }

  .financeApp .parkData{
    width:92%;
    margin:15px auto 0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px;
    padding-bottom:20px
  }

  .financeApp .parkData h2{
    font-size:16px;
    width:92%;
    margin:0 auto;
    padding:15px 0 0 0;
    border-bottom:solid 1px #fafafa
  }
  .financeApp .parkData h2 i{
    float:right;
    font-size:14px;
    font-style: normal;
    font-weight:normal;
    color:#999
  }
  .financeApp .parkData h2 i img{
    width:6px;
    margin-left:5px
  }
  .financeApp .parkData h2 .amounts{
    padding:15px 0 7px 0;
  }
  .financeApp .parkData h2 .amounts span{
    font-size:22px
  }
  .financeApp .parkData h2 .amounts font{
    font-size:12px;
    color:#999;
    font-weight:normal;
    position: relative;
    top:-2px;
  }
  .financeApp .parkData h2 .amounts .tab{
    float:right;
    font-size:12px;
    color:#999;
    margin-top:8px
  }
  .financeApp .parkData h2 .amounts .tab a{
    font-size:12px;
    color:#666;
    margin-left:20px;
    font-weight:normal;
    position: relative;
  }
  .financeApp .parkData h2 .amounts .tab a.curt:after{
    position: absolute;
    content: '';
    background: #333;
    width:15px;
    height: 2px;
    border-radius: 2px;
    left: 50%;
    bottom: -10px;
    transform: translateX(-50%);
  }


  .financeApp ul{
    display:block;
    width:94%;
    margin:0 auto;
    margin-top:15px
  }
  .financeApp ul li{
    display:block;
    width:100%;
    background: #FFFFFF;
    margin-bottom:15px;
    position: relative;
    padding-bottom:15px;
    border-bottom:solid 1px #EBF2FF;
  }
  .financeApp ul li:last-child{
    border-bottom:none;
  }
  .financeApp ul li h2{
    width:92%;
    margin:0 auto;
    font-size:15px;
    padding:15px 0 10px 0;
    letter-spacing: 1px;
    font-weight:500;
    height:30px;
    line-height:30px;
    border-bottom:solid 1px #EBF2FF;
    color:#333;
  }
  .financeApp ul li h2 img{
    float:left;
    width:30px;
    border-radius: 50%;
    margin-right:8px
  }
  .financeApp ul li p{
    font-size:15px;
    padding-left:15px;
    color:#999;
    letter-spacing:1px;
    padding-top:10px;
  }
  .financeApp ul li .point{
    font-size:15px;
    padding-left:15px;
    color:#004aff;
    letter-spacing:1px;
    padding-bottom:15px;
    font-weight:bold
  }
  .financeApp ul li .sr{
    position: absolute;
    top:20px;
    right:10px;
    color:#0FB144;
    font-size:14px;
    font-weight:bold
  }
</style>